import { createSelector } from 'reselect';
import constants from '../../../common/constants/CommonConstants';
import { PIPELINE_TYPE } from '../../../common/constants/PipelineConstatnts';

const pipelines = (state) => state.pipelines.list;
const pipelinesStats = (state) => state.pipelines.statbarData;

export const pipelineSelector = createSelector(
  pipelines,
  (pipelineList) => pipelineList
);

export const pipelineStatsSelector = createSelector(
  pipelinesStats,
  (stats) => stats
);

const listPageData = (state) => state.pipelines.listPageData;
export const listPageDataSelector = createSelector(
  listPageData,
  (data) => data
);

export const opportunitySelector = createSelector(
  pipelineSelector,
  (pipelineList) => {
    return pipelineList.filter((pipeline) => {
      return pipeline.pipelineType === PIPELINE_TYPE.OPPORTUNITY.id;
    });
  }
);

export const riskSelector = createSelector(pipelineSelector, (pipelineList) => {
  return pipelineList.filter((pipeline) => {
    return pipeline.pipelineType === PIPELINE_TYPE.RISK.id;
  });
});

export const pipelinesPartialListSelector = createSelector(
  (state) => state.entityPartialList.list[constants.PIPELINE_LEVEL],
  (pipelineList) => pipelineList
);
